import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { api } from "@/api";
import { useLang, tr } from "@/i18n";

const Stars = ({ n }) => (
    <div className="flex gap-0.5">
        {[1, 2, 3, 4, 5].map((i) => (
            <Star
                key={i}
                size={14}
                className={i <= n ? "text-[#D4AF37]" : "text-[#E6DBCF]"}
                fill={i <= n ? "#D4AF37" : "none"}
            />
        ))}
    </div>
);

export const ReviewsSection = () => {
    const [reviews, setReviews] = useState([]);
    const { lang } = useLang();
    const t = (s) => tr(lang, s);

    useEffect(() => {
        api.get("/reviews").then(({ data }) => setReviews(data)).catch(() => {});
    }, []);

    if (!reviews.length) return null;

    return (
        <section id="reviews" data-testid="reviews-section" className="py-20 lg:py-24 bg-[#FAF6F0]">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <Reveal>
                    <Overline>{t("Voices of Families")}</Overline>
                    <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl text-[#241D19] tracking-tight">
                        {t("What Families Say")}
                    </h2>
                </Reveal>
                <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch">
                    {reviews.map((r, i) => (
                        <Reveal key={r.id} delay={(i % 4) * 0.08} className="h-full">
                            <article
                                data-testid={`review-card-${r.id}`}
                                className="h-full bg-white rounded-2xl border border-[#E6DBCF] p-6 flex flex-col shadow-[0_2px_16px_rgba(36,29,25,0.05)] hover:shadow-[0_12px_36px_rgba(156,55,11,0.12)] transition-shadow duration-500"
                            >
                                <Quote size={22} className="text-[#E5C158]" fill="#E5C158" />
                                <div className="mt-3"><Stars n={r.rating} /></div>
                                <p className="mt-3 text-sm text-[#241D19] leading-relaxed flex-1">"{r.text}"</p>
                                <div className="mt-4 pt-4 border-t border-[#F4EDE2]">
                                    <p className="font-semibold text-sm text-[#241D19]">{r.name}</p>
                                    <p className="text-xs text-[#6E6259] mt-0.5">
                                        {r.location}{r.package_name ? ` · ${r.package_name}` : ""}
                                    </p>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
